import { prop } from '@ipfabric/utils/fp/prop';
import type { GraphState } from 'components/Graph/GraphState';
import type { CollapsedNodeGroupId } from 'components/Graph/model/GraphData';
import { makeMemoizedGetNestedObjectKeys } from 'utils/memoize/makeMemoizedGetObjectKeys';
import { createScopedSelector } from 'utils/react/scopedSelector';

export const selectCollapsedNodeGroupIds: (
  s: GraphState,
) => CollapsedNodeGroupId[] = createScopedSelector(() =>
  makeMemoizedGetNestedObjectKeys(prop('graph', 'collapsedNodeGroups')),
);
